const CONNECTION_CLOSE_DELAY_MS = 1000;

const connectionCloseDelay = (): Promise<void> =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, CONNECTION_CLOSE_DELAY_MS);
  });

export default connectionCloseDelay;
